import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { CreateDesignReceiptAPI } from "api/designReceiptAPI";

const handleThunkError = (err, rejectWithValue) => {
  return rejectWithValue(
    err?.response?.data || {
      success: false,
      message: "Something went wrong",
    }
  );
};

const initialState = {
  receipts: [],
  loading: false,
};

export const createDesignReceipt = createAsyncThunk(
  "designReceipt/createDesignReceipt",
  async (data, { rejectWithValue }) => {
    console.log(data, "<==data");
    try {
      const response = await CreateDesignReceiptAPI(data);
      return response.data;
    } catch (err) {
      console.log("postReceipt error ======>", err);
      return handleThunkError(err, rejectWithValue);
    }
  }
);

export const slackSlice = createSlice({
  name: "slacks",
  initialState,
  reducers: {},
  extraReducers: (builder) => builder,
});

export default slackSlice.reducer;
